module.exports = __webpack_public_path__ + "img/hk_address.ff140501.png";